export default "__VITE_ASSET__d5fiiwku__"